export default __webpack_public_path__ + "static/media/bl6.9f00c6d2.png";